import { getUserLanguage } from 'fso-fincrime-sdk-ui';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import English from '../../assets/locales/en/lang.json';
import French from '../../assets/locales/fr/lang.json';
import Portuguese from '../../assets/locales/pt/lang.json';

const isDebugMode: boolean = window.__RUNTIME_CONFIG__?.REACT_APP_DEBUG_LANGUAGE === 'true';
const defaultLanguage: string = getUserLanguage();

const resources = {
  English,
  French,
  Portuguese,
};

i18next
  .use(initReactI18next)
  .init({
    debug: isDebugMode,
    resources,
    defaultNS: 'translations',
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
  })
  .catch((error) => console.debug('Error initializing i18next', error));
